import { render, staticRenderFns } from "./dropdown-menu.vue?vue&type=template&id=d08ca5b8&scoped=true&"
import script from "./dropdown-menu.vue?vue&type=script&lang=js&"
export * from "./dropdown-menu.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-menu.vue?vue&type=style&index=0&id=d08ca5b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08ca5b8",
  null
  
)

export default component.exports